<template>
  <div class="appt-table">
    <h2>Session History</h2>

    <p v-if="!student.outcomes.length">
      There is no session history yet.
    </p>

    <div v-else class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Counselor</th>
            <th>When</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="outcome in student.outcomes" :key="outcome.id">
            <td>
              <router-link :to="`/student/counselor/profile/${outcome.counselorId}`">
                {{ outcome.counselorName }}
              </router-link>
            </td>
            <td>
              {{ new Date(outcome.when) | dateLongMonthNoYear }}
            </td>
            <td>
              <span v-if="outcome.type.includes('Canceled')">
                Canceled
              </span>
              <span v-else-if="outcome.type === 'BothNoShow'">
                Both the counselor and you did not attend
              </span>
              <span v-else-if="outcome.type === 'CounselorNoShow'">
                The counselor did not attend
              </span>
              <span v-else-if="outcome.type === 'UserNoShow'">
                You did not attend
              </span>
              <span v-else>
                Successful
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionHistory',
  inject:['student'],
}
</script>

<style lang="scss" scoped>
.appt-table {
  h2 {
    color: $green;
    font-size: 28px;
    margin-bottom: 20px;
  }
}
td {
  color: white;
}
th {
  color: white;
  border-top: 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}
</style>
